import { readBlobAsDataURL } from '@/shared/lib/reader'

export async function createImageElementFromBlob(blob: Blob): Promise<HTMLImageElement> {
    const src = await readBlobAsDataURL(blob)

    return new Promise((resolve, reject) => {
        const img = document.createElement('img')
        img.onload = () => resolve(img)
        img.onerror = () => {
            img.remove()
            reject(new Error('Failed to load image from blob'))
        }
        img.src = src
    })
}
